'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var throughInterface = function throughInterface(area) {
  return function (AgentComponent) {
    var _class, _temp;

    var ThroughInterface = (_temp = _class = function (_React$Component) {
      _inherits(ThroughInterface, _React$Component);

      function ThroughInterface() {
        _classCallCheck(this, ThroughInterface);

        return _possibleConstructorReturn(this, (ThroughInterface.__proto__ || Object.getPrototypeOf(ThroughInterface)).apply(this, arguments));
      }

      _createClass(ThroughInterface, [{
        key: 'render',
        value: function render() {
          var _this2 = this;

          return _react2.default.createElement(AgentComponent, _extends({}, this.props, _defineProperty({}, area, {
            update: function update(key, props) {
              var syncUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

              _this2.context.through.update(area, key, props, syncUpdate);
            },
            add: function add(key) {
              _this2.context.through.add(area, key);
            },
            remove: function remove(key) {
              _this2.context.through.remove(area, key);
            }
          })));
        }
      }]);

      return ThroughInterface;
    }(_react2.default.Component), _class.contextTypes = {
      through: _propTypes2.default.object
    }, _temp);


    return ThroughInterface;
  };
};

exports.default = throughInterface;